// 商品ページスライド
$(function(){
  $('.single-item').slick({
    accessibility: true,
    dots: true,
    fade: true,
    arrows : true,
    //appendArrows: $('.arrows'),
    prevArrow: '<button class="slide-arrow prev-arrow"></button>',
    nextArrow: '<button class="slide-arrow next-arrow"></button>'
  });
});


//　クゥクゥページ
$(function(){
  $('.coucou-img').slick({
autoplay: true,//自動的に動き出すか
  infinite: true,//スライドをループさせるかどうか  
accessibility: true,
    dots: true,
    fade: true,
    arrows : false
  });
});




